import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyBToRhALz4-dCfkUtld1jiJMUGp8sLll8c",
  authDomain: "aalap-ec49b.firebaseapp.com",
  projectId: "aalap-ec49b",
  storageBucket: "aalap-ec49b.firebasestorage.app",
  messagingSenderId: "83329874784",
  appId: "1:83329874784:web:219fe18e5aea55ea817c05",
  measurementId: "G-0CH8ER4Y8H"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);

export default app;
